import React, { useCallback, useContext, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import "./sourcing.css";
import axios from "axios";
import { basePath, formatDate, isObject, isValidDateTillCurrent, monthData, validateFile, validateNumber, validatePhoneNumber } from '../Constants/constant';
import { useNavigate, useParams } from 'react-router-dom';
import { AppContext } from '../ContextApi/ContextApi';
import InputField from '../Usables/InputField';
import RefreshButton from '../Usables/RefreshButton';
import PageBanner from '../Usables/PageBanner';
import Loader from '../Usables/Loader';
import NoRecords from '../Usables/NoRecords';
import AddCandidate from '../Usables/AddCandidate';
import EditCandidate from '../Usables/EditCandidate';
import Swal from 'sweetalert2';
import { IoMdAddCircleOutline } from "react-icons/io";
import BasicButton, { ListButton } from '../Usables/Buttons';
import Pagination from '../Usables/Pagination';
import SourcedCandidateList from './SourcedCandidateList';

function Sourcing(props) {
    const { index } = useParams();
    const navigate = useNavigate();
    const { apiHeaderJSON, apiHeaderFile, user } = useContext(AppContext);
    const [sourceModal, setSourceModal] = useState(false);
    const [sourceViewModal, setSourceViewModal] = useState(false);
    const [isUpdate, setIsUpdate] = useState(false);
    const [status, setStatus] = useState(false);
    const [totalResume, setTotalResume] = useState(0);
    const [totalRelevants, setTotalRelevants] = useState(0);
    const [totalPending, setTotalPending] = useState(0);
    const [totalSent, setTotalSent] = useState(0);
    const [candidateEdit, setCandidateEdit] = useState(false);
    const [errors, setErrors] = useState({});
    const [viewCandidateEdit, setViewCandidateEdit] = useState(false);
    const [loadingFilter, setLoadingFilter] = useState(false);
    const [loadingSourcing, setLoadingSourcing] = useState(false);
    const [loadingDelete, setLoadingDelete] = useState(false);
    const [loading, setLoading] = useState(false);
    const [allCompany, setAllCompany] = useState([]);
    const [allPositions, setAllPositions] = useState([]);
    const [allSourceReport, setAllSourceReport] = useState(false);
    const [date, setDate] = useState("");
    const [formData, setFormData] = useState({candidate_resume: null,});
    const [ischanged, setIschanged] = useState({getListChanged: false, fetchFilterDataChanged: false, statusChanged: false});
    const [pagination, setPagination] = useState({page: 1, totalRecords: "", totalPages: "", limit: 10,});
    const [paginationCandidate, setPaginationCandidate] = useState({page: 1, totalRecords: "", totalPages: "", limit: 10,});
    const [candidateId, setCandidateId] = useState(false);
    const [allReports, setAllReports] = useState("");
    const [filterData, setFilterData] = useState({});
    const [filterDataCandidate, setFilterDataCandidate] = useState({});

    const getCompnies = async()=> {
        try {
            const [response] = await Promise.all([
                await axios.get(`${basePath}/getcompanies?id=${localStorage.getItem("userId")}`),
            ]);
            // get compnay list
            const list = response?.data?.map((item)=> {return {value: item?.id, label: item?.company_name}})
            setAllCompany(list);
        } catch (error) {
            console.log(error);
        }
    }

    const getList = useCallback(async()=> {
        try {
            const res = await axios.get(`${basePath}/getfilteredupdatebypage`,{
                params:{
                    limit:pagination?.limit,
                    page:pagination?.page,
                    id:localStorage.getItem("userId"),
                    filter:JSON.stringify(filterData)
                },
                headers:apiHeaderJSON
            });
            // console.log("getfilteredupdatebypage===>", res.data);
            setAllSourceReport(res.data?.update);
            setPagination({...pagination, totalPages: res?.data?.pages, totalRecords: res?.data?.totalRecords});
            setLoading(false);
            setLoadingFilter(false);
        } catch (error) {
            setLoading(false);
            setLoadingFilter(false);
            console.log(error);
        }
    },[pagination, filterData, apiHeaderJSON]);

    useEffect(()=> {
        setLoading("1");
        getList();
        getCompnies();
    },[]);

    const getSourcedCandidate = useCallback(async()=> {
        try {
            const view = "0"
            const apiUrl = `${basePath}/getSourcingReportByDate`;        
            const res = await axios.get(apiUrl, {
                params: {
                    limit: paginationCandidate?.limit,
                    page: paginationCandidate?.page,
                    date: date,
                    id: localStorage.getItem("userId"),
                    filter: JSON.stringify(filterDataCandidate),
                    view: view
                },
                headers: apiHeaderJSON
            });
            setAllReports(res?.data?.Candidates || []);
            setPaginationCandidate({...paginationCandidate, totalPages: res?.data?.pages, totalRecords: res?.data?.totalRecords});
            setLoading(false);
            setLoadingFilter(false);
        } catch (error) {
            setLoading(false);
            setLoadingFilter(false);
            console.error("Error fetching reports:", error);
        }
    },[filterDataCandidate, paginationCandidate, date, apiHeaderJSON]);

    useEffect(()=> {
        if(ischanged?.getListChanged){
            getList();
            setIschanged({...ischanged, getListChanged: false})
        }
        else if (ischanged?.fetchFilterDataChanged) {
            getSourcedCandidate();
            setIschanged({...ischanged, fetchFilterDataChanged: false})
        }
    }, [ischanged]);
    
    const handleDownload = async (canId, candidateName) => {
        try {
            const response = await fetch(`${basePath}/downloadresume/${canId || formData?.id}`,{
                headers:apiHeaderJSON
            });
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `${candidateName.replace(/ /g, "_") || formData?.candidate.replace(/ /g, "_")}_resume_${formatDate(new Date())}.pdf`;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            window.URL.revokeObjectURL(url); // Cleanup the URL object
        } catch (error) {
            console.error('There was a problem with the download:', error);
            if (error?.status === 404) {
                toast.error(error?.response?.error);
            }
            else {
                toast.error("There was a problem with the download");
            }
        }
    }

    const handleExport = async () => {
        try {
            setLoadingFilter("3");
            const response = await axios.get(`${basePath}/getfilteredupdatebypage`, {
                responseType: 'blob', // Ensure response is treated as a blob
                headers:apiHeaderJSON,
                params:{
                    download:"yes",
                    date:date,
                    filter:JSON.stringify(filterData),
                    limit:pagination.limit,
                    page:pagination.page
                }
            });

            // Create a URL for the blob object
            const url = window.URL.createObjectURL(new Blob([response.data]));

            // Create a temporary <a> element to trigger the download
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `Daily_Sourcing_Update_${date}.xlsx`);
            document.body.appendChild(link);
            link.click();

            // Clean up resources
            window.URL.revokeObjectURL(url);
            document.body.removeChild(link);
            setLoadingFilter(false);
        } catch (error) {
            console.error('Error exporting jobs:', error);
            setLoadingFilter(false);
        }
    }
    const handleGlobalSearch = ()=> {
        navigate("/sourced-candidate");
    }
    const handleExportCandidate = async () => {
        try {
            setLoadingFilter("4");
            const response = await axios.get(`${basePath}/getSourcingReportByDate?download=yes&date=${date}&id=${localStorage.getItem("userId")}&filter=${JSON.stringify(filterData)}`, {responseType: 'blob',  headers:apiHeaderJSON});

            // Create a URL for the blob object
            const url = window.URL.createObjectURL(new Blob([response.data]));

            // Create a temporary <a> element to trigger the download
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `Daily_Sourcing_Update_${date}.xlsx`);
            document.body.appendChild(link);
            link.click();

            // Clean up resources
            window.URL.revokeObjectURL(url);
            document.body.removeChild(link);
            setLoadingFilter(false);
        } catch (error) {
            console.error('Error exporting jobs:', error);
            setLoadingFilter(false);
        }
    };

    const getPositions = async()=> {
        try {
            const res = await axios.get(`${basePath}/getcompanies/${parseInt(formData?.company_id)}/positions?id=${localStorage.getItem("userId")}`);
            const list = res?.data?.map((item)=> {
                return {value: item?.id, label: item?.position, location: item?.location, min_ctc: item?.min_ctc, max_ctc: item?.max_ctc, 
                position_questions: item?.PositionQuestions}
            })
            // console.log("list ===>>>",list);
            setAllPositions(list);
        } catch (error) {
            console.log(error?.response?.error)
        }
    }

    useEffect(() => {
        if(formData?.company_id) getPositions();
    }, [formData?.company_id]); 

    // source new candidate 
    const handleSubmit = async(e)=> {
        e.preventDefault();
        const errorList = validateForm();
        console.log("errorList", errorList);
        if (Object.keys(errorList).length > 0) {
            setErrors(errorList);
            return;
        }

        Swal.fire({
        title: 'Are you sure?',
        text: `You want to source ${formData?.candidate_name || ""}!`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: `Yes, Source!`,
        cancelButtonText: 'No, Cancel!',
        confirmButtonColor: '#1F1E30', 
        cancelButtonColor: '#F44336',
        allowOutsideClick:false,
        }).then(async(result) => {
            if (!result.isConfirmed) return;
            try {
                setLoadingSourcing(true);
                const options = {
                    headers: {...apiHeaderFile},
                }
                const data = {
                    ...formData,
                    candidate_phone: `${formData?.candidate_phone || ""}`,
                    candidate_alt_phone: `${formData?.candidate_alt_phone || ""}`,
                    company: formData?.company_id,
                    position: formData?.position_id,
                    candidate_question_answers: formData?.position_questions,
                }
                const response = await axios.post(`${basePath}/addsourcingreport?id=${localStorage.getItem("userId")}`, data, options);
                if (response.status === 200) {
                    getList();
                    handleClose();
                    setCandidateId(false);
                    setStatus(false);
                    getSourcedCandidate();
                    toast.success("Candidate Added Successfully.");
                }
                setLoadingSourcing(false);
            } catch (error) {
                setLoadingSourcing(false);
                console.log(error);
                if (error.response) {
                    toast.error(error.response?.data?.message);
                } else {
                    toast.error("There is some network or server issue!! Please try again later.");
                }
            }
        })
    }
    const validateForm = ()=>{
        const errors = {};
        if(!viewCandidateEdit){        
            if (!formData?.company_id && !viewCandidateEdit) {
                errors.company_id = "Company is required!";
                return errors;
            }
            if (!formData?.position_id && !viewCandidateEdit) {
                errors.position_id = "Position is required!";
                return errors;
            } 
            if ((!formData?.cv_sourced_from || formData?.cv_sourced_from.trim() === "") && !viewCandidateEdit) {
                errors.cv_sourced_from = "This field is required!";
                return errors;
            } 
            if ((!formData?.relevant || formData?.relevant.trim() === "") && !viewCandidateEdit) {
                errors.relevant = "This field is required!";
                return errors;
            } 
            if ((!formData?.sourcing_status || formData?.sourcing_status.trim() === "") && !viewCandidateEdit) {
                errors.sourcing_status = "Sourcing status is required!";
                return errors;
            }
        }

        if (!formData?.candidate || formData?.candidate.trim() === "") {
            errors.candidate = "Candidate name is required!";
            return errors;
        } else if (formData?.candidate.length < 3) {
            errors.candidate = "Name must be at least 3 characters!";
            return errors;
        } else if (!/^[A-Za-z\s]+$/.test(formData?.candidate)) {
            errors.candidate = "Name can only contain letters!";
            return errors;
        }
        // Email validation
        if (!formData?.candidate_email || formData?.candidate_email.trim() === "") {
            errors.candidate_email = "Email is required!";
            return errors;
        } else if (
            !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData?.candidate_email)
        ) {
            errors.candidate_email = "Invalid email address!";
            return errors;
        }

        // mobile number validation
        if (!formData?.phone_code || formData?.phone_code.trim() === "") {
            errors.phone_code = "Required!";
            return errors;
        }
        if (!formData?.candidate_phone || formData?.candidate_phone.trim() === "") {
            errors.candidate_phone = "Mobile number is required!";
        } else if (formData?.phone_code && formData?.candidate_phone) {
            const validateNum = validatePhoneNumber(formData?.phone_code, formData?.candidate_phone);
            if(!validateNum?.isValid && validateNum?.codeError) {
                errors.phone_code = validateNum?.message;
                return errors;
            }
            else if(!validateNum?.isValid && !validateNum?.codeError) {
                errors.candidate_phone = validateNum?.message;
                return errors;
            }
        }
        
        if ((!formData?.phone_alt_code || formData?.phone_alt_code.trim() === "") && formData?.candidate_alt_phone) {
            errors.phone_alt_code = "Required!";
            return errors;
        }
        if (formData?.phone_alt_code && formData?.candidate_alt_phone) {
            const validateNum = validatePhoneNumber(formData?.phone_alt_code, formData?.candidate_alt_phone);
            if(!validateNum?.isValid && validateNum?.codeError) {
                errors.phone_alt_code = validateNum?.message;
                return errors;
            } else if(!validateNum?.isValid && !validateNum?.codeError) {
                errors.candidate_alt_phone = validateNum?.message;
                return errors;
            }
        }
        // if status is Screened or editing already sourced candidate then below fields are required.
        if ((formData?.sourcing_status === "Screened"  && sourceModal) || viewCandidateEdit) {

            if (!formData?.candidate_location || formData?.candidate_location.trim() === "") {
                errors.candidate_location = "Candidate location is required!";
                return errors;
            } else if (!/^[A-Za-z\s]+$/.test(formData?.candidate_location)) {
                errors.candidate_location = "Location can only contain letters!";
                return errors;
            }
            if (!formData?.candidate_qualification || formData?.candidate_qualification.trim() === "") {
                errors.candidate_qualification = "Qualification is required!";
                return errors;
            }
            if (!formData?.current_currency_code) {
                errors.current_currency_code = "Required!";
                return errors;
            }
            if (!formData?.candidate_current_ctc || formData?.candidate_current_ctc.trim() === "") {
                errors.candidate_current_ctc = "Current CTC is required!";
                return errors;
            } else if (!validateNumber(formData?.candidate_current_ctc, 100000000)?.success) {
                errors.candidate_current_ctc = validateNumber(formData?.candidate_current_ctc, 500)?.message;
                return errors;
            }
            if (!formData?.candidate_ectc_type) {
                errors.candidate_ectc_type = "Required!";
                return errors;
            }
            if (!formData?.expected_currency_code) {
                errors.expected_currency_code = "Required!";
                return errors;
            }
            if (!formData?.candidate_expected_ctc || formData?.candidate_expected_ctc.trim() === "") {
                errors.candidate_expected_ctc = "Expected CTC is required!";
                return errors;
            } else if (!validateNumber(formData?.candidate_expected_ctc, 100000000)?.success) {
                errors.candidate_expected_ctc = validateNumber(formData?.candidate_expected_ctc, 500)?.message;
                return errors;
            }
            if (!formData?.candidate_industry || formData?.candidate_industry.trim() === "") {
                errors.candidate_industry = "Industry is required!";
                return errors;
            }
            if (!formData?.candidate_experience || formData?.candidate_experience.trim() === "") {
                errors.candidate_experience = "Experience is required!";
                return errors;
            } else if (!validateNumber(formData?.candidate_experience, 50)?.success) {
                errors.candidate_experience = validateNumber(formData?.candidate_experience, 500)?.message;
                return errors;
            }
            if (!formData?.candidate_notice_period) {
                errors.candidate_notice_period = "This field is required!";
                return errors;
            } else if (!validateNumber(formData?.candidate_notice_period, 500)?.success) {
                errors.candidate_notice_period = validateNumber(formData?.candidate_notice_period, 500)?.message;
                return errors;
            }
            if (!formData?.candidate_gender || formData?.candidate_gender.trim() === "") {
                errors.candidate_gender = "This field is required!";
                return errors;
            }
        }
        else {
            if (formData?.candidate_location && !/^[A-Za-z\s]+$/.test(formData?.candidate_location)) {
                errors.candidate_location = "Location can only contain letters!";
                return errors;
            }
            if (formData?.candidate_current_ctc && !validateNumber(formData?.candidate_current_ctc, 100000000)?.success) {
                errors.candidate_current_ctc = validateNumber(formData?.candidate_current_ctc, 500)?.message;
                return errors;
            }
            if (formData?.candidate_expected_ctc && !validateNumber(formData?.candidate_expected_ctc, 100000000)?.success) {
                errors.candidate_expected_ctc = validateNumber(formData?.candidate_expected_ctc, 500)?.message;
                return errors;
            }
            if (formData?.candidate_experience && !validateNumber(formData?.candidate_experience, 50)?.success) {
                errors.candidate_experience = validateNumber(formData?.candidate_experience, 500)?.message;
                return errors;
            }
            if (formData?.candidate_notice_period && !validateNumber(formData?.candidate_notice_period, 500)?.success) {
                errors.candidate_notice_period = validateNumber(formData?.candidate_notice_period, 500)?.message;
                return errors;
            }
        }
        if (formData?.candidate_dob && !isValidDateTillCurrent(formData?.candidate_dob)) {
            errors.candidate_dob = "DOB should be less or equal to current year!";
            return errors;
        }
        if (formData?.candidate_resume && isObject(formData?.candidate_resume)){
            const valid = validateFile(formData?.candidate_resume, 5, ['application/pdf']);
            if (!valid?.valid) {
                errors.candidate_resume = valid?.message;
                return errors;
            }
        }
        if(!validateMandatory()){
            errors.required = "Required!";
            return errors;
        }
        return errors;
    }

    // valiadte that is any questions answer is empty or not  
    const validateMandatory = () => {
        let isValid = true;

        const updatedQuestions = formData.position_questions.map(item => {
        if (item.is_mandatory === 1 && (!item.response_text || item.response_text.trim() === "")) {
            isValid = false;
            return { ...item, error_text: "This question is mandatory." };
        }
        return { ...item, error_text: "" };
        });

        setFormData(prev => ({
        ...prev,
        position_questions: updatedQuestions
        }));

        return isValid;
    };


    useEffect(() => {
        let resume = 0;
        Array.isArray(allSourceReport) && allSourceReport?.forEach((val) => {
            resume += parseInt(val?.total_cv_sourced);
        });
        let relevant = 0;
        Array.isArray(allSourceReport) && allSourceReport?.forEach((val) => {
            relevant += parseInt(val?.total_cv_relevant);
        });
        let pending = 0;
        Array.isArray(allSourceReport) && allSourceReport?.forEach((val) => {
            pending += parseInt(val?.total_confirmation_pending);
        });
        let sentTo = 0;
        Array.isArray(allSourceReport) && allSourceReport?.forEach((val) => {
            sentTo += parseInt(val?.total_sent_to_client);
        });
        // console.log("typeof resume",typeof resume);
        setTotalResume(resume);
        setTotalRelevants(relevant);
        setTotalPending(pending);
        setTotalSent(sentTo);
        // console.log(resume, relevant, pending, sentTo);
    }, [allSourceReport])

    const handleSourcedView = (e, val) => {
        setSourceViewModal(val?.update_date);
        setDate(val?.update_date); 
        setLoading("2");
        setIschanged({...ischanged, fetchFilterDataChanged: true});
    };
    

    const handleStatus = async() => {
        try {
            const data = {
                candidate_id: candidateId,
                sourcing_status: status,
                recruiter_id: localStorage.getItem("userId"),
            }
            // console.log("handleStatus=========>>>>>>", data);
            const options = {
                headers: { ...apiHeaderJSON },
            }
            const response = await axios.patch(`${basePath}/statuschange`, data, options);
            if (response.status === 200) {
                setLoading(false);
                // console.log(response);
                getSourcedCandidate();
                getList();                    
                toast.success("Candidate Status Updated Successfully");
                setStatus(false);
            }
            else {
                setLoading(false);
                toast.error("Unable to post1");
            }
            } catch(e) {
                setLoading(false);
                console.log(e);
                toast.error("There is some network or server issue!! Please try again later.");
            };
        setIsUpdate(false);
    }

    useEffect(()=>{
        if (ischanged?.statusChanged) {
            handleStatus();
            setIschanged({...ischanged, statusChanged: false});
        }
    }, [ischanged?.statusChanged]);

    const handleCandidateEdit = (e) => {
        e.preventDefault();
        const errorList = validateForm();
        console.log("errorList", errorList);
        if (Object.keys(errorList).length > 0) {
            setErrors(errorList);
            return;
        }
        Swal.fire({
        title: 'Are you sure?',
        text: `${status === "Screened" ? `You want to change status to ${status}!` : "You want update candidate info!"}`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: `Yes, ${status === "Screened" ? "Change" : "Update"}!`,
        cancelButtonText: 'No, Cancel!',
        confirmButtonColor: '#1F1E30', 
        cancelButtonColor: '#F44336',
        allowOutsideClick:false,
        }).then(async(result) => {
            if (!result.isConfirmed) return;
            setLoadingSourcing(true);
            try {
                const data = {
                    ...formData,
                    candidate_phone: `${formData?.candidate_phone || ""}`,
                    candidate_alt_phone: `${formData?.candidate_alt_phone || ""}`,
                    candidate_question_answers: JSON.stringify(formData?.position_questions),
                    recruiter_id: localStorage.getItem("userId"),
                    candidate_resume: null,
                }
                if(status === "Screened") {
                    data.sourcing_status = "Screened";
                }
                if(isObject(formData?.candidate_resume)){
                    data.candidate_resume = formData?.candidate_resume;
                }

                // console.log("editatspipeline data ========>>>>", data);

                const options = {
                    headers: apiHeaderFile,
                }
                const response = await axios.patch(`${basePath}/editatspipeline/${candidateId}`, data, options);
                if (response.status === 200) {
                    handleClose();
                    getSourcedCandidate();
                    setCandidateId(false);
                    setStatus(false);
                    toast.success(response?.data?.message || "Candidate info Updated Successfully");
                }
                else {
                    toast.error(response?.data?.message || "There is some network or server issue!! Please try again later.");
                }
                setLoadingSourcing(false);
            } catch (error) {
                console.log(error);
                setLoadingSourcing(false);
                toast.error(error?.response?.message || "There is some network or server issue!! Please try again later.");
            };
            // if(status === "Screened") handleStatus("e", candidateId);
        });
    }

    const handleDelete = (e) => {
        const {id} = e.target.value;
        Swal.fire({
        title: 'Are you sure?',
        text: `You won't be able to revert this!`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: `Yes, Delete!`,
        cancelButtonText: 'No, Cancel!',
        confirmButtonColor: '#1F1E30', 
        cancelButtonColor: '#F44336',
        allowOutsideClick:false,
        }).then(async(result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: 'Please wait...',
                    html: 'Deleting...',
                    allowOutsideClick: false,
                    didOpen: () => {Swal.showLoading();}
                });
                setLoadingDelete(true);
                const options = {
                    url: `${basePath}/deleteCandidate/${id}`,
                    method: "DELETE",
                    headers: {...apiHeaderJSON},
                }
                axios(options)
                .then((response) => {
                    if (response.status === 200) {
                        getSourcedCandidate();
                        toast.success(response?.data?.message || "Candidate Deleted Successfully");
                        // console.log("Information Deleted successfully");
                    }
                    else {
                        toast.error("Unable to Delete");
                    }
                    Swal.close();
                    setLoadingDelete(false);
                })
                .catch((e) => {
                    Swal.close();
                    setLoadingDelete(false);
                    toast.error("There is some network or server issue!! Please try again later.");
                });
            }
        });
    }

    const handleFilter = useCallback(()=>{ 
        setLoadingFilter("1"); 
        getList();
    },[getList]);

    const handleFilterCandidate = useCallback(()=>{ 
        setLoadingFilter("1"); 
        getSourcedCandidate();
    },[getSourcedCandidate]);

    const handleClear = useCallback(()=> {
        setLoadingFilter("2");
        setFilterData({fromDate: "", toDate: ""});
        setIschanged({...ischanged, getListChanged: true});
    },[ischanged]);

    const handleClearCandidate = useCallback(()=> {
        setLoadingFilter("2");
        setFilterDataCandidate({ candidate: "", company: "", position: "", location: "", relevant: "", status: "", });
        setIschanged({...ischanged, fetchFilterDataChanged: true});
    },[ischanged]);

    const handleRefresh = () => {
        if (!loading || !loadingFilter) {
            setLoading("1");
            getList();
        }
    }
    const handleRefreshCandidate = () => {
        if (!loading || !loadingFilter) {
            setLoading("2");
            getSourcedCandidate();
        }
    }

    const handleChangeForm = useCallback((event,id)=> {
        const {name, value, option} = event?.target;
        // console.log(name, value, option);
        if(name === "position_id"){
            setFormData({ ...formData, [name]: value, location: option?.location, min_ctc: option?.min_ctc, max_ctc: option?.max_ctc, position_questions: option?.position_questions, positionAnswers: []});
            setErrors({...errors, [name]: ""});

        }
        else if (name === "answer") {
            setFormData(prev => ({
                ...prev,
                position_questions: prev.position_questions.map(item =>
                    item.question_id === id
                    ? { ...item, response_text: value, error_text: "" } // remove error on typing
                    : item
                )}));
        } else if (name === "current_currency_code") {
        setFormData({ ...formData, [name]: value, expected_currency_code: value }); setErrors({...errors, [name]: "", expected_currency_code: ""});
        } else {setFormData({ ...formData, [name]: value, }); setErrors({...errors, [name]: ""});}
    },[formData, errors]);

    const handleChangeFilter = useCallback((event)=> {
        const {name, value} = event?.target;
        // console.log("name, value", name, value);
        setFilterData({ ...filterData, [name]: value, });       
    },[filterData]);
    const handleChangeFilterCandidate = useCallback((event)=> {
        const {name, value} = event?.target;
        // console.log("name, value", name, value);
        setFilterDataCandidate({ ...filterDataCandidate, [name]: value, });       
    },[filterDataCandidate]);

    // handling edit button 
    const handleViewCandidateEdit = (val)=> {
        setCandidateId(val?.id);
        setFormData({
            ...formData,
            id: val?.id || null,
            company_id: val?.Position?.company_id || "",
            location: val?.Position?.location || "",
            min_ctc: val?.Position?.min_ctc || "",
            max_ctc: val?.Position?.max_ctc || "",
            cv_sourced_from: val?.cv_sourced_from || "",
            relevant: val?.relevant || "",
            sourcing_status: val?.sourcing_status || "",
            candidate: val?.candidate || "",
            candidate_email: val?.candidate_email || "",
            phone_code: val?.phone_code || "",
            candidate_phone: val?.candidate_phone || "",
            phone_alt_code: val?.phone_alt_code || "",
            candidate_alt_phone: val?.candidate_alt_phone || "",
            candidate_location: val?.candidate_location || "",
            candidate_qualification: val?.candidate_qualification || "",
            current_currency_code: val?.current_currency_code || "",
            candidate_current_ctc: val?.candidate_current_ctc || "",
            candidate_ectc_type: val?.candidate_ectc_type || "",
            expected_currency_code: val?.expected_currency_code || "",
            candidate_expected_ctc: val?.candidate_expected_ctc || "",
            candidate_dob: val?.candidate_dob || "",
            candidate_industry: val?.candidate_industry || "",
            candidate_organization: val?.candidate_organization || "",
            candidate_designation: val?.candidate_designation || "",
            candidate_experience: val?.candidate_experience || "",
            candidate_notice_period: val?.candidate_notice_period || "",
            candidate_gender: val?.candidate_gender || "",
            candidate_resume: val?.resume_link || "",
            candidate_resumes: val?.candidate_resumes,
            candidate_remarks: val?.candidate_remarks || '',
            position_questions: val?.CandidateQnAs,
        });
        setViewCandidateEdit(val);
    }
    
    const handleCancelEdit = () => {
        // console.log("edit val =>", viewCandidate);
        setFormData({
            ...formData,
            company_id: viewCandidateEdit?.Position?.company_id || "",
            location: viewCandidateEdit?.Position?.location || "",
            min_ctc: viewCandidateEdit?.Position?.min_ctc || "",
            max_ctc: viewCandidateEdit?.Position?.max_ctc || "",
            cv_sourced_from: viewCandidateEdit?.cv_sourced_from || "",
            relevant: viewCandidateEdit?.relevant || "",
            sourcing_status: viewCandidateEdit?.sourcing_status || "",
            candidate: viewCandidateEdit?.candidate || "",
            candidate_email: viewCandidateEdit?.candidate_email || "",
            phone_code: viewCandidateEdit?.phone_code || "",
            candidate_phone: viewCandidateEdit?.candidate_phone || "",
            phone_alt_code: viewCandidateEdit?.phone_alt_code || "",
            candidate_alt_phone: viewCandidateEdit?.candidate_alt_phone || "",
            candidate_location: viewCandidateEdit?.candidate_location || "",
            candidate_qualification: viewCandidateEdit?.candidate_qualification || "",
            current_currency_code: viewCandidateEdit?.current_currency_code || "",
            candidate_current_ctc: viewCandidateEdit?.candidate_current_ctc || "",
            candidate_ectc_type: viewCandidateEdit?.candidate_ectc_type || "",
            expected_currency_code: viewCandidateEdit?.expected_currency_code || "",
            candidate_expected_ctc: viewCandidateEdit?.candidate_expected_ctc || "",
            candidate_dob: viewCandidateEdit?.candidate_dob || "",
            candidate_industry: viewCandidateEdit?.candidate_industry || "",
            candidate_organization: viewCandidateEdit?.candidate_organization || "",
            candidate_designation: viewCandidateEdit?.candidate_designation || "",
            candidate_experience: viewCandidateEdit?.candidate_experience || "",
            candidate_notice_period: viewCandidateEdit?.candidate_notice_period || "",
            candidate_gender: viewCandidateEdit?.candidate_gender || "",
            candidate_resume: viewCandidateEdit?.candidate_resume || "",
            candidate_resumes: viewCandidateEdit?.candidate_resumes,
            candidate_remarks: viewCandidateEdit?.candidate_remarks || '',
            position_questions: viewCandidateEdit?.CandidateQnAs,
        });
        setCandidateEdit(false);
    }
    const handleEditOn = ()=> {
        setCandidateEdit(true);
    }
    const handleClose = ()=> {
        console.log("onClose out");
        setSourceModal(false);
        setFormData({});
        setErrors({});
        if (!sourceViewModal) setFilterData({fromDate: "", toDate: ""});
        setFilterDataCandidate({candidate: "", company: "", position: "", location: "", relevant: "", status: ""});
        setViewCandidateEdit(false);
        setCandidateEdit(false);
        setStatus(false);
        if (!viewCandidateEdit) setSourceViewModal(false);  
    }

    const handleChangeStatus = (e,idx,val) => {
        if (e.target.value === "Screened") {
            handleViewCandidateEdit(val);
            setCandidateEdit(true);
            setCandidateId(val?.id);
            setIsUpdate(val?.id);
            setStatus(e.target.value);
        } else if (e.target.value !== val?.sourcing_status) {
            setIschanged({...ischanged, statusChanged: true});
            setCandidateId(val?.id);
            setIsUpdate(val?.id);
            setStatus(e.target.value);
        } 
    }

    const handleLimit = (e)=> {
        setPagination({...pagination, limit: e.target.value});
        setIschanged({...ischanged, getListChanged: true});
    }
    const handlePrev = (e)=> {
        if (pagination?.page > 1) {
            setPagination({...pagination, page: pagination?.page - 1});
            setIschanged({...ischanged, getListChanged: true});
        }
    }
    const handleNext = (e)=> {
        
        if (pagination?.totalPages > pagination?.page) {
            setPagination({...pagination, page: pagination?.page + 1});
            setIschanged({...ischanged, getListChanged: true});
        }
    }
    const handleLimitCandidate = (e)=> {
        setPaginationCandidate({...paginationCandidate, limit: e.target.value});
        setIschanged({...ischanged, fetchFilterDataChanged: true});
    }
    const handlePrevCandidate = (e)=> {
        if (paginationCandidate?.page > 1) {
            setPaginationCandidate({...paginationCandidate, page: paginationCandidate?.page - 1});
            setIschanged({...ischanged, fetchFilterDataChanged: true});
        }
    }
    const handleNextCandidate = (e)=> {
        
        if (paginationCandidate?.totalPages > paginationCandidate?.page) {
            setPaginationCandidate({...paginationCandidate, page: paginationCandidate?.page + 1});
            setIschanged({...ischanged, fetchFilterDataChanged: true});
        }
    }

    const handleBack = ()=> {
        navigate(-1);
    }

    return (
        <section className='  w-full'>
            {/* RefreshButton => used for refresh table data */}
            <RefreshButton onClick={handleRefresh} position='fixed' />
            <ListButton onClick={()=> navigate(`/sourcing-list/${index}`)} />
            {/* PageBanner => used to show page banner info */}
            <PageBanner pageName='Daily Sourcing' pageTitle='Ready to start your day' src='/img/master.png' alt="screened candidate" />
            {viewCandidateEdit ?
                <div className=' w-full h-screen fixed left-0 top-0 z-40 flex items-center justify-center blurBack'>
                    <div className=' bg-white overflow-auto mx-10 mb-5 p-10 rounded-3xl candidateInfoBox'>
                        <EditCandidate
                        onChange={handleChangeForm}
                        onCancel={handleCancelEdit}
                        onClose={handleClose}
                        onSubmit={handleCandidateEdit}
                        OnlyView={!user[index]?.edit_access}
                        onEdit={handleEditOn}
                        data={formData}
                        onDownload={handleDownload}
                        loading={loadingSourcing}
                        errors={errors}
                        disabled={!candidateEdit}
                        />
                    </div>
                </div> : null}
            {sourceModal ?
                <div className=' w-full h-screen fixed left-0 top-0 z-20 flex items-center justify-center blurBack'>
                    <div className=' bg-white overflow-auto mx-10 mb-5 p-10 rounded-3xl candidateInfoBox'>
                        <AddCandidate
                        onChange={handleChangeForm}
                        onCancel={handleClose}
                        onClose={handleClose}
                        onSubmit={handleSubmit}
                        onEdit={false}
                        data={formData}
                        companyList={allCompany}
                        positionList={allPositions}
                        loading={loadingSourcing}
                        errors={errors}
                        disabled={loadingSourcing}
                        />
                    </div>
                </div>
            : null}
            {sourceViewModal && 
                (<SourcedCandidateList 
                filter={filterDataCandidate} rows={allReports} pagination={paginationCandidate} status={status} isUpdate={isUpdate} loading={loading} loadingFilter={loadingFilter} loadingDelete={loadingDelete}
                onChange={handleChangeFilterCandidate} onClose={handleClose} onRefresh={handleRefreshCandidate} 
                onFilter={handleFilterCandidate} onEdit={handleViewCandidateEdit} onStatusChange={handleChangeStatus} onClear={handleClearCandidate} 
                onDelete={handleDelete} onExport={handleExportCandidate} onLimit={handleLimitCandidate} onPrev={handlePrevCandidate} onNext={handleNextCandidate}
                />)
            }
            {/* filter */}
            <div className=' grid lg:grid-cols-5 md:grid-cols-3 sm:grid-cols-2 grid-cols-1 items-center gap-3 grayBlurShadow bg-white p-3 mt-5 rounded-xl'>
                {user[index]?.add_access ?
                <div>
                    <div onClick={()=> {setFormData({}); setSourceModal(true);}} className='darkPurple my-2 mx-auto w-fit cursor-pointer rounded-full py-2 px-3 text-white flex items-center gap-2 font-bold grayBlurShadow hoverGreen navAnimation'>
                        <IoMdAddCircleOutline className=' text-4xl text-white hoverGreen' />
                        <button>Source Candidate</button>
                    </div>
                </div>
                : null}
                <InputField  id="fromDate" name="fromDate" type="date" label="From Date:"
                disabled={loading === '1'}
                value={filterData?.fromDate}
                onChange={handleChangeFilter}
                />
                <InputField  id="toDate" name="toDate" type="date" label="To Date:"
                disabled={loading === '1'}
                value={filterData?.toDate}
                onChange={handleChangeFilter}
                />
                <div className="flex gap-3 col-span-1">
                    <div className=" flex flex-col">
                        <label className="block  text-left font-medium text-gray-700 mb-1 text-nowrap">Apply Filter</label>
                        <BasicButton onClick={handleFilter} buttonName='Apply Filter' className='darkPurple text-nowrap' shadow={true}
                        disabled={loading || loadingFilter || (!filterData?.fromDate && !filterData?.toDate)} 
                        loading={loadingFilter === "1"} loadingMessage="Loading" rounded="lg" textAlign="center" fontWeight="bold" onHover="hoverGreen" />
                    </div>
                    <div className=" flex flex-col">
                        <label className="block  text-left font-medium text-gray-700 mb-1 text-nowrap">Clear Filter</label>
                        <BasicButton onClick={handleClear} buttonName='Clear Filter' className="bg-red-600 text-nowrap" shadow={true}
                        disabled={loading || loadingFilter || (!filterData?.fromDate && !filterData?.toDate)} 
                        loading={loadingFilter === "2"} loadingMessage="Loading" rounded="lg" textAlign="center" fontWeight="bold" onHover="hover:bg-red-900" />
                    </div>
                    <div className=" flex flex-col">
                        <label className="block  text-left font-medium text-gray-700 mb-1 text-nowrap">Excel Export</label>
                        <BasicButton onClick={handleExport} buttonName='Excel' className="bg-green-800 text-nowrap" shadow={true}
                        disabled={loading || loadingFilter || allSourceReport?.length === 0} 
                        loading={loadingFilter === "3"} loadingMessage="Loading" rounded="lg" textAlign="center" fontWeight="bold" onHover="hover:bg-green-950" />
                    </div>
                    <div className=" flex flex-col">
                        <label className="block  text-left font-medium text-gray-700 mb-1 text-nowrap">All Sourced</label>
                        <BasicButton onClick={handleGlobalSearch} buttonName='All Sourced' className="bg-blue-800 text-nowrap" shadow={true}
                        disabled={loading || loadingFilter || allSourceReport?.length === 0} 
                        loading={loadingFilter === "3"} loadingMessage="Loading" rounded="lg" textAlign="center" fontWeight="bold" onHover="hoverGreen" />
                    </div>
                </div>
            </div>
            {
                loading === "1" ?
                <Loader/> :
                Array.isArray(allSourceReport) && allSourceReport?.length >= 1 ?
                <section className='tableWrapper'>
                    <div className='tableBody'>
                        <table className='w-full table-fixed border-collapse'>
                            <thead className='tableHead'>
                                <tr className=' bg-gray-200'>
                                    <th >Sr.No.</th>
                                    <th>Source Date</th>
                                    <th>CV's Sourced</th>
                                    <th>Relevant CV's</th>
                                    <th>Pending</th>
                                    <th>Sent</th>
                                    {(user[index]?.view_access || user[index]?.edit_access) && <th>View Details</th>}
                                </tr>
                            </thead>
                            <tbody className='tableBody  '>
                                {
                                    Array.isArray(allSourceReport) && allSourceReport?.map((val, idx) => {
                                        return (
                                            <tr key={val?.id} id={val?.id} className=' backWhite font-semibold text-sm'>
                                                <td>{idx + 1}</td>
                                                <td>{val?.update_date.split("-")[2]} {monthData[parseInt(val?.update_date.split("-")[1])]} {val?.update_date.split("-")[0]}</td>
                                                <td>{val?.total_cv_sourced?.toString()?.padStart(2,0)}</td>
                                                <td>{val?.total_cv_relevant?.toString()?.padStart(2,0)}</td>
                                                <td>{val?.total_confirmation_pending?.toString()?.padStart(2,0)}</td>
                                                <td>{val?.total_sent_to_client?.toString()?.padStart(2,0)}</td>
                                                {(user[index]?.view_access || user[index]?.edit_access) && <td> 
                                                    <button className='darkPurple text-white font-semibold rounded-xl px-4 text-sm py-1 hoverGreen' 
                                                    onClick={(e) => handleSourcedView(e, val)}>
                                                    View</button>
                                                </td>}
                                            </tr>
                                        )
                                    })
                                }
                                <tr className=' bg-gray-600 text-white rounded-lg text-xl font-semibold'>
                                    <th></th>
                                    <th>Total</th>
                                    <th>{totalResume?.toString()?.padStart(2,0)}</th>
                                    <th>{totalRelevants?.toString()?.padStart(2,0)}</th>
                                    <th>{totalPending?.toString()?.padStart(2,0)}</th>
                                    <th>{totalSent?.toString()?.padStart(2,0)}</th>
                                    {(user[index]?.view_access || user[index]?.edit_access) && <th></th>}
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <Pagination onLimitChange={handleLimit} onPrevChange={handlePrev} onNextChange={handleNext}
                    limit={pagination?.pagelimit} totalRecords={pagination?.totalRecords} allPages={pagination?.totalPages} page={pagination?.page}
                    disabledPrev={pagination?.page === 1} disabledNext={pagination?.page === pagination?.totalPages}
                    />
                </section> :
                <NoRecords/>
            }
        </section>
    );
}


export default Sourcing;